import {Grid, Typography} from '@mui/material';
import {IBackground} from '../../../../api/models';
import {AddPhotoAlternateRounded} from '@mui/icons-material';
import {BackgroundUploadModal} from './BackgroundUploadModal';

interface BackgroundImagePickerProps {
    sectionId: string;
    open: boolean;
    setOpen: (newState: boolean) => void;
    isBackgroundPresent: boolean;
    backgroundInfo?: IBackground;
}

export const BackgroundImagePicker = ({open, setOpen, sectionId, isBackgroundPresent}: BackgroundImagePickerProps) => {
    return (
        <>
            <br />
            <Grid container>
                <Grid item md={12} xs={12} sm={12}>
                    <div onClick={() => setOpen(true)}>
                        <Typography
                            sx={{
                                marginTop: 1,
                                fontWeight: 700,
                                color: 'black',
                                fontFamily: 'Poppins',
                                justifyContent: 'center',
                                cursor: 'pointer',
                            }}
                            variant='body1'>
                            <AddPhotoAlternateRounded />
                            {isBackgroundPresent ? 'Add background image' : 'Replace background image'}
                        </Typography>
                    </div>
                </Grid>
            </Grid>
            <BackgroundUploadModal
                open={open}
                setOpen={(newState: boolean) => setOpen(newState)}
                sectionId={sectionId}
            />
        </>
    );
};
